import { IRoute } from "@/types";
import { lazy } from "react";

const infoGraphicRoutes: IRoute[] = [
  {
    path: "/infographic",
    element: lazy(() => import("@/modules/infographic/pages")),
    sub: [
      {
        path: "",
        subElement: lazy(() => import("@/modules/infographic/pages")),
      },
      {
        path: "phc",
        subElement: lazy(() => import("@/modules/infographic/pages/phcView")),
      },
    ],
  },
];

export default infoGraphicRoutes;
